export enum vimsSFTPActionNames {
  SET_VIMS_SFTP_FILE_ID = 'SET_VIMS_SFTP_FILE_ID',
  SET_IS_LOADING = 'SET_IS_LOADING',
}

export interface VimsSFTPState {
  fileId: string;
  isLoading: boolean | undefined;
}

interface SetVimsSFTPAction {
  type: typeof vimsSFTPActionNames.SET_VIMS_SFTP_FILE_ID;
  payload: VimsSFTPState;
}

interface SetVimsSFTPLoading {
  type: typeof vimsSFTPActionNames.SET_IS_LOADING;
  payload: boolean;
}

export type VimsSFTPActionTypes = SetVimsSFTPAction | SetVimsSFTPLoading;
